import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import * as Icons from '@material-ui/icons';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  handleReload() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="60vh"
          p={4}
          textAlign="center"
        >
          <Icons.ErrorOutline style={{ fontSize: 64, color: '#e53935', marginBottom: 16 }} />
          <Typography variant="h5" gutterBottom>
            Ocurrió un error inesperado
          </Typography>
          <Typography variant="body1" color="textSecondary" style={{ marginBottom: 24 }}>
            La página no pudo cargarse correctamente. Por favor, intente recargar.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Icons.Refresh />}
            onClick={this.handleReload}
          >
            Recargar página
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
